import { useTranslation } from 'react-i18next';

// Components
import Page from '../components/templates/Page/Page';

/**
 * ErrorFallback view component
 * @returns {JSX.Element} The ErrorFallback component
 */
function ErrorFallback() {
  // Hooks
  const { t } = useTranslation();

  return (
    <Page page={{ template: 'table', format: null, path: '' }}>
      <h1 className="flex margin-top-m text-center align-center">{t('errorFallback.title')}</h1>
    </Page>
  );
}

export default ErrorFallback;
